module.exports = __webpack_public_path__ + "static/lazienki-255224e10fae467885ce12c3e821c435.jpg";